"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromotionCodeUsedCommand = void 0;
class PromotionCodeUsedCommand {
    constructor(input) {
        this.input = input;
    }
    execute(config) {
        const { customer, transaction_code, coupon_code } = this.input;
        const { cdp: cdpTracking } = config;
        const hashCustomerId = cdpTracking?.helper.md5(customer?.id ?? '');
        cdpTracking?.web_event.track('promotion_code', 'used', {
            items: [
                {
                    id: coupon_code,
                    name: coupon_code,
                    transaction_code: transaction_code,
                    type: 'promotion_code',
                    code_status: 4,
                },
            ],
            dims: {
                ...(customer && {
                    customers: {
                        customer_id: customer?.id ? hashCustomerId : 'no-customer-id',
                        name: customer?.name ?? 'no-customer-name',
                        email: customer?.email?.toLowerCase() ?? 'no-customer-email',
                        phone: customer?.phone ?? 'no-customer-phone',
                        cdp_source: 'Production',
                    },
                }),
                purchase: {
                    id: transaction_code,
                    name: `#${transaction_code}`,
                },
            },
            extra: {
                cdp_property_id: 564990540,
            },
        });
        return Promise.resolve();
    }
}
exports.PromotionCodeUsedCommand = PromotionCodeUsedCommand;
